module.exports = __webpack_public_path__ + "img/4-text.47bbd195.png";